exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-33f9455d] {\n  margin: 2px 0;\n  white-space: nowrap;\n}\n.btn-light[data-v-33f9455d] {\n  background-color: #E0E0E0;\n}\n.special-title[data-v-33f9455d]::after {\n  content: \"\";\n  display: block;\n  height: 0.25rem;\n  width: 60px;\n  left: 0;\n  margin: 0;\n  background: #00ACC1;\n  border-radius: 999px;\n  margin-top: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-33f9455d","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/experience/Index.vue
// module id = 1966
// module chunks = 0